import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import '@resources/js/analytics'
import initAiButton from '@resources/js/components/ai-button/initAiButton'

initSharedPromotion()

initAiButton()
